import { Col, Form } from "react-bootstrap";
import DateFilter from "../../components/tools/DateFilter";
import LoadingButton from "../../components/Loading/LoadingButton";

export default function PreOrderCodeFilters({ filters, isFetching, refetch }) {
  return (
    <div className="card-shadow rounded-1 p-3 d-flex flex-wrap row-gap-2">
      <Col xs={12} sm={6} md={4} xl={3} className="px-1 bs">
        <Form.Label>تعداد نمایش</Form.Label>
        <Form.Select
          value={filters.get("items")}
          onChange={e => filters.set("items", e.target.value)}
        >
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="50">50</option>
          <option value="100">100</option>
          <option value="200">200</option>
          <option value="500">500</option>
          <option value="1000">1000</option>
        </Form.Select>
      </Col>

      <Col xs={12} sm={6} md={4} xl={3} className="px-1">
        <Form.Label>شماره سفارش</Form.Label>
        <Form.Control
          type="number"
          value={filters.get("numberParcel") || ""}
          onChange={e => filters.set("numberParcel", e.target.value)}
        />
      </Col>

      <Col xs={12} sm={6} md={4} xl={3} className="px-1">
        <Form.Label>کد پیش سفارش</Form.Label>
        <Form.Control
          value={filters.get("preOrderCode") || ""}
          onChange={e => filters.set("preOrderCode", e.target.value)}
        />
      </Col>

      <Col xs={12} sm={6} md={4} xl={3} className="px-1 bs">
        <Form.Label>وضعیت</Form.Label>
        <Form.Select
          value={filters.get("status")}
          onChange={e => filters.set("status", e.target.value)}
        >
          <option value="">همه</option>
          <option value="1">قابل استفاده</option>
          <option value="2">متصل</option>
        </Form.Select>
      </Col>

      <div className="w-100 d-flex flex-wrap row-gap-2">
        <Col xs={12} sm={6} md={4} xl={3} className="px-1">
          <DateFilter
            value={filters.get("startDate")}
            label="از تاریخ"
            onChange={value => filters.set("startDate", value)}
          />
        </Col>

        <Col xs={12} sm={6} md={4} xl={3} className="px-1">
          <DateFilter
            value={filters.get("endDate")}
            label="تا تاریخ"
            onChange={value => filters.set("endDate", value)}
          />
        </Col>
      </div>

      <div className="w-100">
        <LoadingButton
          center
          className="btn-primary"
          isLoading={isFetching}
          title={isFetching ? "در حال دریافت" : "اعمال تایید"}
          onClick={() => {
            filters.set("page", 1);
            refetch();
          }}
        />
      </div>
    </div>
  );
}
